import { unformat, toFixed } from 'accounting';

const DEFAULT_DECIMAL_PRECISION = 4;

export const parseIntValue = (value) => {
  if (Number.isNaN(value) || !value) {
    return 0;
  }
  return parseInt(value, 10) || 0;
};

export const parseFloatValue = (value) => {
  if (Number.isNaN(value) || !value) {
    return 0;
  }
  return parseFloat(value) || 0;
};

// Rounds a number to a certain precision
export const formatToPrecision = (
  value,
  precision = DEFAULT_DECIMAL_PRECISION,
) => unformat(toFixed(value, precision));
